//#region Imports
import { useEffect, useState } from 'react';
import {
  Autocomplete,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Skeleton,
  TextField,
  Typography,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import moment from 'moment';

import 'react-toastify/dist/ReactToastify.css';
import '../../../scss/Components/_modal.scss';
import customAxios from '../../../utils/customAxios';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
//#endregion

const HEADERS = {
  headers: {
    Authorization: 'bearer ' + localStorage.getItem('token'),
  },
};

const ModalS = ({ show, onHide, getSites, selectedClients }) => {
  const [name, setName] = useState('');
  const [client, setClient] = useState(null);
  const [addressStreet, setAddressStreet] = useState('');
  const [addressNumber, setAddressNumber] = useState('');
  const [addressColony, setAddressColony] = useState('');
  const [addressCityId, setAddressCityId] = useState('');
  const [addressStateId, setAddressStateId] = useState('');
  const [addressCountryId, setAddressCountryId] = useState('');
  const [addressPC, setAddressPC] = useState('');
  const [cr, setCr] = useState('');
  const [isPriority, setIsPriority] = useState(null);
  const [notes, setNotes] = useState('');
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [clientsTi, setClientsTi] = useState([]);
  const [selectedClientsTi, setSelectedClientsTi] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [coordanates, setCoordanates] = useState({
    latitude: null,
    longitude: null,
  });
  const [entryDate, setEntryDate] = useState(null);
  const [equalDate, setEqualDate] = useState(null);
  const [prevDate, setPrevDate] = useState(null);
  const [kms, setKms] = useState('');
  const [km1, setKm1] = useState('');
  const [kmLevelHrs, setKmLevelHrs] = useState('');
  const [kmLevel, setKmLevel] = useState('');

  const { siteStreetNameString, siteAddressNumString, notesString } =
    useTranslationHook();

  useEffect(() => {
    if (show) {
      fetchCountries();
      fetchClients();
      fetchClientTis();
    }
  }, [show]);

  const fetchCountries = async () => {
    setIsFetching(true);
    try {
      const endpoint = `${GlobalVariables.getURL()}autofillCountryDetails`;
      const response = await customAxios.get(endpoint, HEADERS);

      if (response.status === 200) {
        setCountries(response.data.countries);
      }
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    } finally {
      setIsFetching(false);
    }
  };

  const fetchClients = async () => {
    try {
      const endpoint = `${GlobalVariables.getURL()}listClients`;
      const response = await customAxios.get(endpoint, HEADERS);

      if (response.status === 200) {
        setClients(response.data);
      }
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    }
  };

  const fetchClientTis = async () => {
    const endpoint = `${GlobalVariables.getURL()}client-ti/listAllClientTi`;
    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      if (response.status === 204) {
        setClientsTi([]);
      } else {
        setClientsTi(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (addressCountryId) {
      fetchStates();
    } else {
      setAddressStateId(null);
      setStates([]);
      setAddressCityId(null);
      setCities([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressCountryId]);

  const fetchStates = async () => {
    try {
      const endpoint = `${GlobalVariables.getURL()}statesByCountry/${addressCountryId}`;
      const response = await customAxios.get(endpoint, HEADERS);

      if (response.status === 204) {
        setStates([]);
        return;
      }

      setStates(response.data);
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    }
  };

  useEffect(() => {
    if (addressStateId) {
      fetchCities();
    } else {
      setAddressCityId(null);
      setCities([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressStateId]);

  const fetchCities = async () => {
    try {
      const endpoint = `${GlobalVariables.getURL()}cititesByState/${addressStateId}`;
      const response = await customAxios.get(endpoint, HEADERS);

      if (response.status === 204) {
        setCities([]);
        return;
      }

      setCities(response.data);
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title: error.response?.data?.message || 'Error',
      });
    }
  };

  const resetFormFields = () => {
    setName('');
    setClient(null);
    setClients([]);
    setAddressStreet('');
    setAddressNumber('');
    setAddressColony('');
    setAddressCityId(null);
    setCities([]);
    setAddressStateId(null);
    setStates([]);
    setAddressCountryId(null);
    setCountries([]);
    setAddressPC('');
    setNotes('');
    setCr('');
    setIsPriority(null);
    setCoordanates({
      latitude: null,
      longitude: null,
    });
    setEntryDate(null);
    setEqualDate(null);
    setPrevDate(null);
    setKms('');
    setKm1('');
    setKmLevel('');
    setKmLevelHrs('');
    setSelectedClientsTi([]);
    setClientsTi([]);
  };

  const createSite = async (event) => {
    event.preventDefault();

    // Frontend validation
    const missingFields = [];

    if (!client) missingFields.push('Plaza');
    if (!name.trim()) missingFields.push('Nombre de la sucursal');
    if (!addressCountryId) missingFields.push('País');
    if (!addressStateId) missingFields.push('Estado');
    if (!addressCityId) missingFields.push('Municipio / Delegación');
    if (!addressColony.trim()) missingFields.push('Colonia');
    if (!addressStreet.trim()) missingFields.push('Calle');
    if (!addressNumber.trim()) missingFields.push('Número');
    if (!addressPC.trim()) missingFields.push('Código postal');
    if (isPriority === null) missingFields.push('¿Es sucursal prioritaria?');

    if (missingFields.length > 0) {
      getToast({
        status: 'error',
        title: `Campos requeridos faltantes: ${missingFields.join(', ')}`,
      });
      return;
    }

    setIsLoading(true);

    try {
      const endpoint = `${GlobalVariables.getURL()}createSite/${client}`;
      const response = await customAxios.post(
        endpoint,
        {
          name: name,
          address_street: addressStreet,
          address_number: addressNumber,
          address_colony: addressColony,
          address_city_id: addressCityId,
          address_state_id: addressStateId,
          address_country_id: addressCountryId,
          address_postal_code: addressPC,
          notes,
          cr,
          is_priority: isPriority,
          assigned_to: null,
          client_ti: selectedClientsTi.map((cti) => cti.id),
          // client_ti: clientTi,
          // extra_client_ti: extraClientTi,
          latitude:
            coordanates.latitude === '' || coordanates.latitude == null
              ? null
              : Number(coordanates.latitude),
          longitude:
            coordanates.longitude === '' || coordanates.longitude == null
              ? null
              : Number(coordanates.longitude),
          entry_date: entryDate
            ? moment.utc(entryDate).add(1, 'day').format('YYYY-MM-DD')
            : null,
          equal_date: equalDate
            ? moment.utc(equalDate).add(1, 'day').format('YYYY-MM-DD')
            : null,
          prev_date: prevDate
            ? moment.utc(prevDate).add(1, 'day').format('YYYY-MM-DD')
            : null,
          kms: kms || null,
          km1: km1 || null,
          kmnivel: kmLevel || null,
          kmnivel_hrs: kmLevelHrs || null,
        },
        HEADERS,
      );

      if (response.status === 200) hide();
    } catch (error) {
      console.log('🚀 ~ error:', error);
      getToast({
        status: 'error',
        title:
          error.response?.data?.message ||
          'Error al crear sucursal. Vuelve a intentarlo.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const hide = () => {
    onHide();
    getToast({
      status: 'success',
      title: 'Sucursal creada exitosamente en la base de datos.',
    });
    resetFormFields();
    let endpoint = `${GlobalVariables.getURL()}listClientSites`;
    if (selectedClients.length > 0) {
      endpoint += `?id=${selectedClients}`;
    }
    getSites(endpoint);
  };

  const handleClose = () => {
    onHide();
    resetFormFields();
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      adapterLocale={moment.locale()}
    >
      <Dialog open={show} maxWidth="xl" fullWidth onClose={handleClose}>
        <DialogTitle>
          <Typography className="inventory-movmodal-title">
            Nueva sucursal
          </Typography>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 20,
            top: 20,
            width: 40,
            height: 40,
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </IconButton>
        <DialogContent dividers>
          <form id="site-form" onSubmit={createSite}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <Autocomplete
                    disabled={isLoading}
                    options={clients}
                    value={clients.find((cl) => cl.id === client) || null}
                    getOptionLabel={(cl) => cl.business_name || ''}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    onChange={(_, newValue) =>
                      setClient(newValue ? newValue.id : null)
                    }
                    renderInput={(params) => (
                      <TextField
                        disabled={isLoading}
                        required
                        {...params}
                        label="Plaza"
                        placeholder="Plaza..."
                      />
                    )}
                  />
                )}
              </Grid>

              <Grid item xs={12}>
                <Divider>Información de la sucursal</Divider>
              </Grid>

              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    fullWidth
                    label="Nombre de la sucursal"
                    placeholder="Nombre de la sucursal..."
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    fullWidth
                    label="CR"
                    placeholder="CR..."
                    type="text"
                    value={cr}
                    onChange={(e) => setCr(e.target.value)}
                  />
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <Autocomplete
                    disabled={isLoading}
                    options={countries}
                    value={
                      countries.find((c) => c.id === addressCountryId) || null
                    }
                    getOptionLabel={(country) => country.co_name || ''}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    onChange={(_, newValue) =>
                      setAddressCountryId(newValue ? newValue.id : null)
                    }
                    renderInput={(params) => (
                      <TextField
                        disabled={isLoading}
                        required
                        {...params}
                        label="País"
                        placeholder="País..."
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <Autocomplete
                    disabled={isLoading}
                    options={states}
                    value={states.find((s) => s.id === addressStateId) || null}
                    getOptionLabel={(s) => s.st_name || ''}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    onChange={(_, newValue) =>
                      setAddressStateId(newValue ? newValue.id : null)
                    }
                    renderInput={(params) => (
                      <TextField
                        disabled={isLoading}
                        required
                        {...params}
                        label="Estado"
                        placeholder="Estado..."
                      />
                    )}
                  />
                )}
              </Grid>

              <Grid item xs={12} md={4}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <Autocomplete
                    disabled={isLoading}
                    options={cities}
                    value={cities.find((c) => c.id === addressCityId) || null}
                    getOptionLabel={(cities) => cities.ci_name || ''}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    onChange={(_, newValue) =>
                      setAddressCityId(newValue ? newValue.id : null)
                    }
                    renderInput={(params) => (
                      <TextField
                        disabled={isLoading}
                        required
                        {...params}
                        label="Municipio / Delegación"
                        placeholder="Municipio / Delegación..."
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="Colonia"
                    placeholder="Colonia..."
                    type="text"
                    value={addressColony}
                    onChange={(e) => setAddressColony(e.target.value)}
                    required
                  />
                )}
              </Grid>

              <Grid item xs={12} md={4}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label={siteStreetNameString}
                    placeholder={`${siteStreetNameString}...`}
                    type="text"
                    value={addressStreet}
                    onChange={(e) => setAddressStreet(e.target.value)}
                    required
                  />
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label={siteAddressNumString}
                    placeholder={`${siteAddressNumString}...`}
                    value={addressNumber}
                    onChange={(e) => setAddressNumber(e.target.value)}
                    required
                  />
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="Código postal"
                    placeholder="Código postal..."
                    type="number"
                    value={addressPC}
                    onChange={(e) => setAddressPC(e.target.value)}
                    required
                  />
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <Autocomplete
                    multiple
                    disabled={isLoading}
                    options={clientsTi}
                    value={selectedClientsTi}
                    getOptionLabel={(client) =>
                      client.full_name || client.name || ''
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    onChange={(_, newValue) => setSelectedClientsTi(newValue)}
                    renderInput={(params) => (
                      <TextField
                        disabled={isLoading}
                        {...params}
                        label="Contacto Sucursal"
                        placeholder="Contacto Sucursal..."
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <FormControl required error={isPriority === null}>
                    <FormLabel id="demo-radio-buttons-group-label" required>
                      ¿Es sucursal prioritaria?
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      name="radio-buttons-group"
                      value={isPriority}
                      onChange={(e) => setIsPriority(e.target.value)}
                      row
                    >
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="Sí"
                      />
                      <FormControlLabel
                        value="0"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                )}
              </Grid>

              <Grid item xs={12}>
                <Divider>Fechas y datos adicionales</Divider>
              </Grid>

              <Grid item xs={12} md={4}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <DatePicker
                    sx={{ width: '100%' }}
                    label="Fecha ingreso"
                    value={entryDate}
                    onChange={(newDate) => setEntryDate(newDate)}
                    disabled={isLoading}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <DatePicker
                    sx={{ width: '100%' }}
                    label="Fecha de igual a"
                    value={equalDate}
                    onChange={(newDate) => setEqualDate(newDate)}
                    disabled={isLoading}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={4}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <DatePicker
                    sx={{ width: '100%' }}
                    label="Fecha anterior"
                    value={prevDate}
                    onChange={(newDate) => setPrevDate(newDate)}
                    disabled={isLoading}
                  />
                )}
              </Grid>

              <Grid item xs={12} md={3}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="KMS"
                    placeholder="KMS..."
                    type="number"
                    value={kms}
                    onChange={(e) => {
                      const value = e.target.value;
                      setKms(value === '' ? '' : Number(value));
                    }}
                    inputProps={{
                      min: 0,
                      step: 1,
                    }}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={3}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="KM1"
                    placeholder="KM1..."
                    type="number"
                    value={km1}
                    onChange={(e) => {
                      const value = e.target.value;
                      setKm1(value === '' ? '' : Number(value));
                    }}
                    inputProps={{
                      min: 0,
                      step: 1,
                    }}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={3}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="KM Nivel"
                    placeholder="KM Nivel..."
                    type="number"
                    value={kmLevel}
                    onChange={(e) => {
                      const value = e.target.value;
                      setKmLevel(value === '' ? '' : Number(value));
                    }}
                    inputProps={{
                      min: 0,
                      step: 1,
                    }}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={3}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="HRS KMNIVEL"
                    placeholder="HRS KMNIVEL..."
                    type="number"
                    value={kmLevelHrs}
                    onChange={(e) => {
                      const value = e.target.value;
                      setKmLevelHrs(value === '' ? '' : Number(value));
                    }}
                    inputProps={{
                      min: 0,
                      step: 1,
                    }}
                  />
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="Latitud"
                    placeholder="Coordenadas de latitud"
                    type="number"
                    value={coordanates.latitude}
                    onChange={(e) => {
                      const value = e.target.value;
                      setCoordanates({
                        ...coordanates,
                        latitude: value === '' ? '' : Number(value),
                      });
                    }}
                    inputProps={{ step: 'any' }}
                  />
                )}
              </Grid>
              <Grid item xs={12} md={6}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label="Longitud"
                    placeholder="Coordenadas de longitud"
                    type="number"
                    value={coordanates.longitude}
                    onChange={(e) => {
                      const value = e.target.value;
                      setCoordanates({
                        ...coordanates,
                        longitude: value === '' ? '' : Number(value),
                      });
                    }}
                    inputProps={{ step: 'any' }}
                  />
                )}
              </Grid>

              <Grid item xs={12}>
                {isFetching ? (
                  <Skeleton variant="rounded" height={56} />
                ) : (
                  <TextField
                    disabled={isLoading}
                    fullWidth
                    label={notesString}
                    placeholder={`${notesString}...`}
                    type="text"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                  />
                )}
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            form="site-form"
            type="submit"
            disabled={isLoading || isFetching}
          >
            {isLoading ? (
              <CircularProgress size="2rem" />
            ) : (
              <Typography>Guardar</Typography>
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};

export default ModalS;
